import { Navigate } from 'react-router-dom';

const Admininroute = ({ children }) => {
  let role = localStorage.getItem('role');
  if (role) {
    role = role.replace(/['"]/g, '').toLowerCase().trim();
  }
  return role === 'admin' ? children : <Navigate to='/login' />;
};

export default Admininroute;


